import React from 'react'
import { SvgIconProps } from './Home'

const SvgTimeIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "18"}
    height={height ?? "18"}
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      fill={fill ?? "#353535"}
      d="M9 0C4.061 0 0 4.061 0 9s4.061 9 9 9 9-4.061 9-9-4.061-9-9-9zm6.805 9c0 3.732-3.073 6.805-6.805 6.805-3.732 0-6.805-3.073-6.805-6.805 0-3.732 3.073-6.805 6.805-6.805 3.732 0 6.805 3.073 6.805 6.805z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M10.098 8.561V5.488c0-.658-.44-1.097-1.098-1.097-.659 0-1.098.439-1.098 1.097V9c0 .33.11.55.33.769l2.524 2.524c.22.22.439.33.768.33.33 0 .55-.11.769-.33a1.061 1.061 0 000-1.536L10.098 8.56z"
    ></path>
  </svg>
)


export default SvgTimeIcon